
/*
  This file is auto-generated by generate-icon-components.js. Do not edit it manually.
*/
import { html, css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

export const FhiIconUserSelector = "fhi-icon-user";

/**
 * ## FhiIconUser
 * 
 * {@link https://designsystem.fhi.no/?path=/docs/ikoner--docs}
 * 
 * @tag fhi-icon-user
 * @element fhi-icon-user
 */
@customElement(FhiIconUserSelector)
export class FhiIconUser extends LitElement {

  /**
   * Sets the color for the icon.
   * Should preferably be a color token. See [Color Tokens](https://designsystem.fhi.no/?path=/docs/design-tokens-farger--docs)
   * @type {string}
   */ 
  @property({ type: String }) color: string = "currentcolor";

  /**
   * Sets the size of the icon. Can be one of the predefined sizes, a number value, rem or px.
   * Number values are treated as px.
   * @type { 'xsmall' | 'small' | 'medium' | 'large' | number | string}
   */
  @property({ type: String }) size: 'xsmall' | 'small' | 'medium' | 'large' | number | `${number}px` | `${number}rem` = 'medium';

  private get _size(): string {
    switch (this.size) {
      case 'xsmall': 
        return '1rem'; 
      case 'small':
        return '1.25rem';
      case 'medium':
        return '1.5rem'; 
      case 'large':
        return '2rem'; 
      default:
        if (String(this.size).endsWith('px') || String(this.size).endsWith('rem')) {
          return String(this.size);
        }
        if (isNaN(Number(this.size))) {
          console.warn(`Invalid size value: ${this.size}. Falling back to default size '1.5rem'.`)
          return '1.5rem';
        }
        return `${this.size}px`;
    }
  }

  render() {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${this._size}" height="${this._size}" fill="${this.color}"><path d="M16.25 8a4.25 4.25 0 1 0-8.5 0 4.25 4.25 0 0 0 8.5 0m1.5 0a5.74 5.74 0 0 1-2.63 4.828 8.75 8.75 0 0 1 3.068 1.985A8.75 8.75 0 0 1 20.75 21a.75.75 0 0 1-1.5 0 7.25 7.25 0 0 0-6.89-7.241L12 13.75A7.25 7.25 0 0 0 4.75 21a.75.75 0 0 1-1.5 0 8.75 8.75 0 0 1 2.563-6.187 8.75 8.75 0 0 1 3.066-1.985A5.75 5.75 0 1 1 17.75 8"/></svg>
    `;
  }
      
  static styles = css`
    :host {
      display: flex;
      max-height: min-content;
      max-width: min-content;
    }
  `;
  }
